export const TEXTS = {
  AWS_UPLOAD_ERROR: "Failed to upload #{count} of #{totalCount} images to AWS.",
  CLEAR_BUTTON_LABEL: "Clear",
  DISCARD_BUTTON_LABEL: "Discard",
  FIELD_REQUIRED_ERROR: "The field is required.",
  GENERIC_UPLOAD_ERROR: "Failed to submit images.",
  REPLACE_BUTTON_LABEL: "Replace",
  SELECT_BUTTON_LABEL: "Select",
  UNKNOWN_IMAGE_ERROR: "The image is not defined in the schema.",
};
